<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3">
      <v-card-title class="headline justify-space-between">
        <div>
          <v-btn
            color="green"
            dark
            @click="showingDeleted = !showingDeleted"
          >
            <span v-if="!showingDeleted">Показать удаленных</span>
            <span v-else>Скрыть удаленных</span>
          </v-btn>
          <v-btn
            class="ml-2"
            color="green"
            dark
            @click="downloadUsersCsv"
          >
            <span>Скачать CSV</span>
          </v-btn>
        </div>
      </v-card-title>
      <v-data-table class="mb-3 mx-3"
                    :headers="headers"
                    :items="users"
                    :item-class="item => item.isDeleted ? 'deletedUser clickable-row' : 'clickable-row'"
                    no-data-text="Пусто"
                    no-results-text="Результатов нет"
                    hide-default-footer
                    :loading="tableLoading"
                    loading-text="Загрузка"
                    :items-per-page="10"
      >
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
              :pagination="pagination"
              :options="options"
              @update:options="updateOptions"
              :items-per-page-options="[10, 50, 100, -1]"
              items-per-page-text="$vuetify.dataTable.itemsPerPageText"/>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: true,
      search: '',
      showingDeleted: false,
      headers: [
        {
          text: '#',
          align: 'start',
          value: 'id',
        },
        {
          text: 'ФИО',
          align: 'start',
          value: 'fullName',
        },
        {
          text: 'Email',
          align: 'start',
          value: 'email',
          sortable: false,
        },
        {
          text: 'Роль',
          align: 'start',
          value: 'roleName',
        },
      ],
    }
  },
  computed: {
    users: function () {
      return this.$store.getters.users.filter(user => this.showingDeleted || !user.isDeleted);
    }
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'reports', disabled: true},
      {text: 'users', disabled: true},
      {text: 'emails', disabled: true},
    ])
  },
  methods: {
    downloadUsersCsv: function() {
      var csvString = this.users.map((user) =>  `"${user.email}"`).join('\n');
      var filename = 'export_' + new Date().toLocaleDateString() + '.csv';
      var link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('target', '_blank');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString));
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  created() {
    this.$store.dispatch('updateUsers').then(() => {
      this.tableLoading = false
    });
  }
}
</script>

<style>
.deletedUser {
  background-color: #e5d4d4;
}
</style>
